module.exports = __webpack_public_path__ + "static/media/alert.46e4e21d.mp3";